import dbc from '@/api/list/tableList';

const tableList = {
  namespaced: true,
  state: {
    aa: 'cc',
    roleList: {
      list: [],
      pageNum: 1,
      total: 0,
    },

    serviceList: {
      list: [],
      pageNum: 1,
      total: 0,
    },
  },
  getters: {
    // permissions(state) {
    //   return state.permissions;
    // },
  },

  actions: {
    /**
     * 获取
     * @param {*} store
     * @param {*} param
     */
    getRoleList({ commit }, param) {
      return dbc.getRoleList(param).then((content) => {
        commit('setRoleList', content);
      });
    },

    /**
     * 获取
     * @param {*} store
     * @param {*} param
     */
    getServiceList({ commit }, param) {
      return dbc.getServiceList(param).then((content) => {
        commit('setServiceList', content);
        return true;
      });
    },
  },

  mutations: {
    // 设置错误次数，大于3次数，出现验证码
    // setLoginCount: (state, count) => {},

    setRoleList(state, content) {
      const { list, pageNum, total } = content.page;
      state.roleList.list = list;
      state.roleList.pageNum = pageNum;
      state.roleList.total = total;
    },

    setServiceList(state, content) {
      const { list, pageNum, total } = content.page;
      state.serviceList.list = list;
      state.serviceList.pageNum = pageNum;
      state.serviceList.total = total;
    },
  },
};

export default tableList;

// getRoleList', 'getServiceList
